import React, { useRef } from "react";
import { LanguageProvider } from "context/LanguageContext";
import {
  ShelterSettingConsumer,
  ShelterSettingProvider,
} from "context/ShelterSettingContext";
import IShelter from "interfaces/IShelter";
import { ShelterForm } from "components/Forms";
import IShelterSponsor from "interfaces/IShelterSponsor";
import { SpecieConsumer, SpecieProvider } from "context/SpecieContext";
import { BreedConsumer, BreedProvider } from "context/BreedContext";
import { Button, Divider } from "antd";
import { DonationSponsor } from "../DonationSponsor";

export interface IPetProfileControlProps {
  data: IShelter;
  uuid: string;
  extras: any;
}

const PetProfileControl = (props: IPetProfileControlProps) => {
  let refPetProfile =
    useRef<InstanceType<typeof ShelterForm.PetProfile>>(null);
  let refLimitControl =
    useRef<InstanceType<typeof ShelterForm.LimitControl>>(null);

  let refDonationSponsor = useRef<{
    handleSave: () => Promise<void>;
  }>()


  const handleSave = async () => {
    if (refDonationSponsor?.current) {
      await refDonationSponsor.current?.handleSave()
    }

    if (refPetProfile.current) {
      await refPetProfile.current.form.submit();
    }

    if (refLimitControl.current) {
      await refLimitControl.current.formRef.submit();
    }
  };

  return (
    <>
      <ShelterSettingProvider>
        <LanguageProvider>
          <ShelterSettingConsumer>
            {(context) => (
              <>
                <ShelterForm.PetProfile
                  data={props.data}
                  uuid={props.uuid}
                  ref={refPetProfile}
                  context={props.extras.shelterContext}
                  settingsContext={context}
                  shelterSponsorSettings={
                    context.shelterSettings?.find(
                      (setting) => setting.type_key === "SPONSOR"
                    )?.value as IShelterSponsor
                  }
                  dispatchSaveSponsorSetting={
                    context.requestShelterSettingSponsorSave
                  }
                />
                <Divider />
                <DonationSponsor uuid={props.uuid} ref={refDonationSponsor as any} />
                <Divider />
                <SpecieProvider>
                  <BreedProvider>
                    <ShelterSettingProvider>
                      <SpecieConsumer>
                        {(specieContext) => (
                          <BreedConsumer>
                            {(breedConsumer) => (
                              <ShelterSettingConsumer>
                                {(context) => (
                                  <>
                                    <ShelterForm.LimitControl
                                      ref={refLimitControl}
                                      uuid={props.uuid}
                                      context={props.extras.shelterContext}
                                      settingsContext={context}
                                      specieContext={specieContext}
                                      breedContext={breedConsumer}
                                    />
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      size="large"
                                      loading={props.extras.shelterContext.fetching || context.fetching}
                                      onClick={handleSave}
                                      ref={(refs) => {
                                        if (refPetProfile.current?.actionRefs) {
                                          refPetProfile.current.actionRefs.save =
                                            refs;
                                        }
                                        if (
                                          refLimitControl.current?.actionRefs
                                        ) {
                                          refLimitControl.current.actionRefs.save =
                                            refs;
                                        }
                                      }}
                                      block
                                    >
                                      Save
                                    </Button>
                                  </>
                                )}
                              </ShelterSettingConsumer>
                            )}
                          </BreedConsumer>
                        )}
                      </SpecieConsumer>
                    </ShelterSettingProvider>
                  </BreedProvider>
                </SpecieProvider>
              </>
            )}
          </ShelterSettingConsumer>
        </LanguageProvider>
      </ShelterSettingProvider>
    </>
  );
};

export { PetProfileControl };
